import type {GetLimits_limits as Limits} from 'nutshell-graphql-types';

export type MonthlyUsage = {
    limit: number | null | undefined;
    remaining: number;
    currentUsage: number;
    allTimeUsage: number | null | undefined;
};

export const getUsageFromLimits = (limits?: Limits | null): MonthlyUsage | null | undefined => {
    if (!limits) {
        return null;
    }

    let monthlyUsage = null;
    if (limits.currentPlanLimit === 0) {
        monthlyUsage = {
            limit: 0,
            remaining: 0,
            currentUsage: limits.currentUsage,
            allTimeUsage: limits.allTimeUsage,
        };
    } else {
        monthlyUsage = {
            limit: limits.currentPlanLimit ? limits.currentPlanLimit : null,
            // dont show negative numbers
            remaining: Math.max(
                limits.currentPlanLimit ? limits.currentPlanLimit - limits.currentUsage : Infinity,
                0
            ),
            currentUsage: limits.currentUsage,
            allTimeUsage: limits.allTimeUsage,
        };
    }

    return monthlyUsage;
};
